import { useEntityCollectionInitializer } from 'store/entityCollection';
import { useInspectionStore } from '../../store';

/** Binds the template list to the mounted view; loading and events are the store's actions. */
export function useInspectionTemplatesInitializer(): void {
  useEntityCollectionInitializer(useInspectionStore.use.inspectionTemplatesCollection());
}
